import React from 'react';
import { useTranslation } from 'react-i18next';
import { BarChartOutlined, RadarChartOutlined, ApartmentOutlined, AppstoreAddOutlined, AuditOutlined, CommentOutlined } from '@ant-design/icons';
import './Content.css';

interface ContentProps {
  isMobile?: boolean;
}

const Content: React.FC<ContentProps> = ({ isMobile }) => {
  const { t } = useTranslation();

  return (
    <div id="trending-products" className="home-page-wrapper content0-wrapper">
      <div className="home-page content0">
        <div className="title-wrapper">
          <h2>{t('productsServices', 'Sản phẩm thịnh hành')}</h2>
        </div>
        <div className="content0-block-wrapper">
          <div className="content0-block">
            <div className="content0-block-item">
              <BarChartOutlined className="content0-block-icon" style={{ fontSize: '60px' }} />
              <h3 className="content0-block-title">{t('service1Title', 'One-stop business access')}</h3>
              <p>{t('service1Content', 'Payment, settlement, accounting access products quadruple efficiency')}</p>
            </div>
          </div>
          <div className="content0-block">
            <div className="content0-block-item">
              <RadarChartOutlined className="content0-block-icon" style={{ fontSize: '60px' }} />
              <h3 className="content0-block-title">{t('service2Title', 'Alipay payment')}</h3>
              <p>{t('service2Content', 'Payment SDK, payment API, payment integration solution')}</p>
            </div>
          </div>
          <div className="content0-block">
            <div className="content0-block-item">
              <ApartmentOutlined className="content0-block-icon" style={{ fontSize: '60px' }} />
              <h3 className="content0-block-title">{t('service3Title', 'Operational data')}</h3>
              <p>{t('service3Content', 'Business data analysis, data visualization, data mining')}</p>
            </div>
          </div>
          <div className="content0-block">
            <div className="content0-block-item">
              <AppstoreAddOutlined className="content0-block-icon" style={{ fontSize: '60px' }} />
              <h3 className="content0-block-title">{t('service4Title', 'Service 4')}</h3>
              <p>{t('service4Content', 'Description for service 4')}</p>
            </div>
          </div>
          <div className="content0-block">
            <div className="content0-block-item">
              <AuditOutlined className="content0-block-icon" style={{ fontSize: '60px' }} />
              <h3 className="content0-block-title">{t('service5Title', 'Service 5')}</h3>
              <p>{t('service5Content', 'Description for service 5')}</p>
            </div>
          </div>
          <div className="content0-block">
            <div className="content0-block-item">
              <CommentOutlined className="content0-block-icon" style={{ fontSize: '60px' }} />
              <h3 className="content0-block-title">{t('service6Title', 'Service 6')}</h3>
              <p>{t('service6Content', 'Description for service 6')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;